import axios from "axios";
import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import Url from "../../../Url";
import { DropDownResponse } from "./Model";
import { headers } from "../../../components/Utility";

type InitialState = {
  loading: boolean;
  patientList: DropDownResponse;
  successMsg: string;
  errorMsg: string;
  status: 0;
};
const initialState: InitialState = {
  loading: false,
  patientList: {} as DropDownResponse,
  successMsg: "",
  errorMsg: "",
  status: 0,
};

export const patientList = createAsyncThunk<DropDownResponse>(
  "patientList/patientList",
  async (_, { rejectWithValue }) => {
    return await axios
      .get(Url.apiURL + "/patientapp/api/patient/patient_list_dropdown", {
        headers,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) =>
        rejectWithValue(
          error.response.data.non_field_errors[0] ||
            error.response.message ||
            "Something went wrong"
        )
      );
  }
);

const patientListSlice = createSlice({
  name: "patientList",
  initialState,
  reducers: {
    updatePatientListResMsg: (state) => {
      state.successMsg = "";
      state.errorMsg = "";
    },
    clearPatientListAPIRes: (state) => {
      state.successMsg = "";
      state.errorMsg = "";
      state.patientList = {} as DropDownResponse;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(patientList.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(
      patientList.fulfilled,
      (state, action: PayloadAction<DropDownResponse>) => {
        state.loading = false;
        state.patientList = action.payload;
        state.successMsg = "Participant list fetched Successful";
        state.errorMsg = "";
      }
    );
    builder.addCase(patientList.rejected, (state, action) => {
      state.loading = false;
      state.patientList = {} as DropDownResponse;
      state.successMsg = "";
      state.errorMsg = String(action.payload!);
    });
  },
});
export const { updatePatientListResMsg, clearPatientListAPIRes } =
  patientListSlice.actions;
export default patientListSlice.reducer;
